// extracted by mini-css-extract-plugin
export default {"flickrIcon":"MuwRKk"};